import { Link } from "react-router-dom";
import IconsCloseSmall from "../assets/svg/iconsCloseSmall.svg";
import {
  getAlertProperties,
  getAlertInfo,
  prepareContent,
} from "../service/alert.service";
import t from "../service/translate.service";
import moment from "moment";

export const StackedNotifications = ({
  notifications,
  onClose,
  onContentClick
}) => {
  const items = notifications.filter((notification) => !notification.seen && !notification?.content?.includes('<p hidden="">long</p>'));
  return (
    items.length > 0 && (
      <div className="alert-list" role="region" aria-live="polite" aria-label={t.NOTIFICATION_LIST}>
        {items.map((notification, index) => {
          const { statusClass } = getAlertProperties(notification);
          const { sName, isUrl } = getAlertInfo(notification);
          const { alertStatus } = notification;
          const notificationContent = localStorage.getItem("locale") === 'en' ? `${notification?.content?.length > 250 ? notification.content?.substring(0, 243)?.trimEnd() + '...' : notification.content}` : `${notification?.contentDe?.length > 250 ? notification?.contentDe?.substring(0, 243)?.trimEnd() + '...' : notification?.contentDe}`
          if (notification?.content?.includes('<p hidden="">long</p>')) return <></>
          return (
            <article
              className={
                notification.type === "general" || notification.type === "letter"
                  ? "itemGeneral notification-group"
                  : `item notification-group ${
                      alertStatus ? `contract-overview-item-${alertStatus}` : ""
                    }`
              }
              key={index}
              role="alert"
              aria-live="assertive"
            >
              <div
                className={`${
                  notification.type === "letter" ? "letters" : ""
                } notification`}
              >
                {onClose !== null && (
                  index === 0 ? (
                    <Link
                      className="close"
                      style={{ zIndex: "99" }}
                      onClick={() => onClose(notification.id)}
                    >
                      <img src={IconsCloseSmall} />
                    </Link>
                  ) : (
                    <button
                      className="close button-nostyle"
                      disabled={index !== 0}
                      style={{ zIndex: "99" }}
                      onClick={() => onClose(notification.id)}
                    >
                      <img src={IconsCloseSmall} />
                    </button>
                  )
                )}
                <div
                  className="content"
                  onClick={() => onContentClick(notification)}
                  style={{ cursor: "pointer" }}
                  tabIndex={index === 0 ? 0 : -1}
                  role="button"
                  aria-label={t.VIEW_NOTIFICATIONS}
                >
                  <div className="message">
                    <div className="status">
                      <span className={`status ${statusClass}`} aria-label={t[statusClass]}>
                        {t[statusClass]}
                      </span>{" "}
                      {notification.sName || sName}
                    </div>

                    {isUrl || notification.setDangerously ? (
                      isUrl ? (
                        <div className="contract-number">
                          {prepareContent(notification, 'home')}
                        </div>
                      ) : (
                        <div
                          className="contract-number"
                          dangerouslySetInnerHTML={{
                            __html: notificationContent
                          }}
                          aria-label={t.NOTIFICATION_DETAILS}
                        ></div>
                      )
                    ) : (
                      <div className="basic-content">
                        <p>{notificationContent}</p>
                      </div>
                    )}

                    {notification.created_at && (
                      <div className="date" aria-label={t.NOTIFICATION_DATE}>
                        {moment(notification.created_at)
                          .locale(localStorage.getItem("locale") === "de" ? "de" : "en")
                          .format("dddd, MMMM Do YYYY, HH:mm")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    )
  );
};
